import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "menu",
    "link",
    "header",
    "openIcon",
    "closeIcon",
    "overlay",
  ];
  static values = {
    sections: {
      type: Array,
      default: ["home", "about", "products", "applications", "news", "contact"],
    },
    staticActive: { type: Boolean, default: false },
  };

  connect() {
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden");
    const open = !this.menuTarget.classList.contains("hidden");
    this.overlayTarget.classList.toggle("hidden", !open);
    if (this.hasOpenIconTarget)
      this.openIconTarget.classList.toggle("hidden", open);
    if (this.hasCloseIconTarget)
      this.closeIconTarget.classList.toggle("hidden", !open);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.overlayTarget.classList.add("hidden");
    if (this.hasOpenIconTarget) this.openIconTarget.classList.remove("hidden");
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.add("hidden");
  }

  onScroll() {
    const scrolled = window.scrollY > 40;
    if (this.hasHeaderTarget) {
      this.headerTarget.classList.toggle("shadow-lg", scrolled);
      this.headerTarget.classList.toggle("shadow-black/25", scrolled);
      this.headerTarget.classList.toggle("bg-primary", scrolled);
      this.headerTarget.classList.toggle("bg-primary/95", !scrolled);
      this.headerTarget.classList.toggle("backdrop-blur-sm", !scrolled);
    }

    if (this.staticActiveValue) return;

    let active = this.sectionsValue[0];
    for (const id of this.sectionsValue) {
      const el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= 100) active = id;
    }

    this.linkTargets.forEach((link) => {
      const isActive = link.dataset.section === active;
      link.classList.toggle("text-accent", isActive);
      link.classList.toggle("text-white/75", !isActive);
      const bar = link.querySelector("[data-nav-bar]");
      if (bar) {
        bar.classList.toggle("w-4", isActive);
        bar.classList.toggle("w-0", !isActive);
      }
    });
  }
}
